import  React from 'react'
import { StageStyled } from './StageStyled'
const Stage= ({children})=>{
    return (
        <StageStyled>{children}</StageStyled>
    )
}

export default Stage;